<template>
  <q-no-ssr class="layout">
    <Header />
    <router-view class="layout-view" />
    <CallWaiter />
  </q-no-ssr>
</template>
<script>
import { Header } from 'src/components/header/index';
import { getStoreInfo } from 'src/api/home';
import CallWaiter from 'src/pages/full_dine_in/components/CallWaiter.vue';


export default {
  components: { Header, CallWaiter },
  data() {
    return {
      config: {},
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.config = val.meta.header || {};
      },
      deep: true,
      immediate: true,
    },
    language: {
      handler(val) {
        this.$i18n.locale = val;
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    this.$i18n.locale = this.language || 'id-ID';
  },
  mounted() {
    setTimeout(async () => {
      if (!this.language) {
        let language;
        const { data, code } = await getStoreInfo();
        if (code === 200) {
          language = data.storeDefaultLanguage;
          this.$store.commit('Menu/updateLanguage', language || 'id-ID');
        }
      }
      this.$i18n.locale = this.language;
    }, 500);
  },
};
</script>
<style scoped lang="scss">
.layout {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
  &-view {
    height: 100%;
    overflow: auto;
  }
}
</style>
